import * as Api from '@ViewModels';
import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { useAutomationTemplateQuery } from '../../../../queries/Automation';
import { LoadingSpinner } from '../../LoadingSpinner';
import { AutomationPreviewStep } from './presentation';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	/** Default = true */
	showPublished?: boolean;
	styles?: StyleDeclarationValue[];
	templateId?: string;
	impersonationContext?: Api.IImpersonationContext;
}

export const AutomationPreview: React.FC<IProps> = props => {
	const { className, styles = [], templateId, showPublished = true, impersonationContext } = props;

	const { data: template, isLoading } = useAutomationTemplateQuery({
		id: templateId,
		enabled: !!templateId,
		impersonationContext,
	});

	if (!templateId) {
		return null;
	}

	if (isLoading || !template) {
		return (
			<div className={`${css(styleSheet.container, ...styles)} automation-preview ${className || ''}`}>
				<LoadingSpinner type='large' />
			</div>
		);
	}

	const steps = (showPublished ? template.published?.steps : template.draft?.steps) || template.published?.steps || [];

	return (
		<div className={`${css(styleSheet.container, ...styles)} automation-preview ${className || ''}`}>
			{steps.map(step => {
				return (
					<AutomationPreviewStep
						template={template}
						key={step.id}
						showPublished={showPublished}
						step={step}
						steps={steps}
						impersonationContext={impersonationContext}
					/>
				);
			})}
		</div>
	);
};
